const axios = require("axios");

const getProductsRelated = async ( country, category, code ) => {
  try {
    const response = await axios.get(
      `${process.env.GATSBY_API_URL}/api/products/related?country=${country}&category=${category}&product_code=${code}`,
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

module.exports = { getProductsRelated };
